import React, { useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import dayjs from "dayjs";
import apiClient from "../../BaseUrl/apiClient.js";
import "../../css/entry.css";
import "../../css/color.css";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { useAuthentication } from "../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../constants/constants";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "@mui/material";
function IndentEdit() {
  const [varindentNumber, setvarindentNumber] = useState("");
  const [vardateofIndent, setvardateofIndent] = useState(null);
  const [varitemname, setvaritemname] = useState("");
  const [varindentItemQty, setvarindentItemQty] = useState(0);
  const [varindentItemValue, setvarindentItemValue] = useState(0);
  const [error, setError] = useState("");
  // const [dateerror, setDateError] = useState("");
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const startRef = useRef(null);
  const today = dayjs();
  const minCalDate = dayjs("2024-01-01");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  let indentId = state.indent_id;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const urights = tokenServiceDetails?.userrights;
  const handleQuantityChange = (value) => {
    setvarindentItemQty(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setvarindentItemValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  // Function to fetch Consignee from the API
  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const UpdateIndentData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!vardateofIndent) {
      formErrors.errDate = "Invalid Indent Date";
    }

    if (parseFloat(varindentItemQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (varindentItemValue.length === 0)
      formErrors.val = "Value should be more then zero";

    if (varindentItemQty.length === 0)
      formErrors.qty = "Qty should be more then zero";

    if (parseFloat(varindentItemValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (varindentNumber.length === 0)
      formErrors.indent = "Indent Number Should not be Blank";

    if (varitemname.length === 0)
      formErrors.name = "Item Name Should not be Blank";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const Indentdt = new Date(vardateofIndent);
      const indentreceiptdt =
        Indentdt.getFullYear() +
        "/" +
        parseInt(Indentdt.getMonth() + 1) +
        "/" +
        Indentdt.getDate();

      // console.log(varindentNumber);
      // console.log(indentreceiptdt);
      // console.log(consignee);
      // console.log(varindentItemQty);
      // console.log(varindentItemValue);
      // console.log(varitemname);
      // console.log(indentId);
      // console.log(ip);
      // console.log(uname);

      apiClient
        .post("/indentupdate", {
          vIndentNumber: varindentNumber,
          vIndentDate: indentreceiptdt,
          vConsigneeCode: consignee,
          vIndentQty: varindentItemQty,
          vIndentValue: varindentItemValue,
          vIndentItemName: varitemname,
          vIndentID: indentId,
          vip: ip,
          entryuser: uname,
          unit,
          urgency: isChecked,
        })
        .then(function (response) {
          navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          setError(error);
        });
    }
  };

  const getIndentData = async (e) => {
    try {
      const response = await apiClient.post("/IndentEditDetails", {
        uname: uname,
        indentId: String(indentId),
      });
      const data = response.data[0];
      setvarindentNumber(data.IndentNumber);
      setconsignee(data.ConsigneeCode);
      setvaritemname(data.IndentItemName);
      setvarindentItemQty(data.IndentQty);
      setvarindentItemValue(data.IndentValue);
      setvardateofIndent(dayjs(data.IndentDate));
      setunit(data.unit);
      setIsChecked(data.urgency === 1 ? true : false);
      //console.log(data.urgency);
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      
    }
    fetchConsignees();
    getIndentData();
    fetchUnit();

    


  }, []);
  const { auth } = useAuthentication();

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
  <>
    <style>
      {`
        /* =====================================================
           INDENT EDIT - RESPONSIVE DASHBOARD THEME
        ===================================================== */

        .indent-edit-page {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          padding: 12px;

          box-sizing: border-box;

          overflow-x: hidden;
        }


        /* =====================================================
           MAIN CARD
        ===================================================== */

        .indent-edit-card {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          background: #ffffff !important;

          border-radius: 16px !important;

          border: 1px solid #dce5f0 !important;

          box-shadow:
            0 6px 24px rgba(0, 68, 145, 0.10) !important;

          overflow: hidden;

          box-sizing: border-box;
        }


        /* =====================================================
           HEADER
        ===================================================== */

        .indent-edit-header {
          width: 100%;

          padding: 18px 24px;

          background:
            linear-gradient(
              135deg,
              #0d47a1 0%,
              #1565c0 48%,
              #1976d2 100%
            );

          color: #ffffff;

          box-sizing: border-box;
        }


        .indent-edit-title {
          margin: 0;

          font-size: 20px;

          font-weight: 700;

          line-height: 1.3;

          letter-spacing: 0.2px;
        }


        .indent-edit-subtitle {
          margin-top: 4px;

          font-size: 13px;

          opacity: 0.90;
        }


        /* =====================================================
           CONTENT
        ===================================================== */

        .indent-edit-content {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          padding: 22px;

          box-sizing: border-box;
        }


        /* =====================================================
           SECTION TITLE
        ===================================================== */

        .indent-edit-section-title {
          display: flex;

          align-items: center;

          gap: 8px;

          margin-bottom: 14px;

          color: #1565c0;

          font-size: 14px;

          font-weight: 700;
        }


        .indent-edit-section-title::before {
          content: "";

          width: 4px;

          height: 18px;

          border-radius: 5px;

          background:
            linear-gradient(
              180deg,
              #0d47a1,
              #1976d2
            );
        }


        /* =====================================================
           MAIN FORM GRID
        ===================================================== */

        .indent-edit-grid {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          display: grid;

          grid-template-columns:
            repeat(2, minmax(0, 1fr));

          gap: 18px;

          box-sizing: border-box;
        }


        .indent-edit-field {
          width: 100%;
          min-width: 0;

          box-sizing: border-box;
        }


        /* =====================================================
           ITEM NAME - FULL WIDTH
        ===================================================== */

        .indent-edit-full {
          grid-column: 1 / -1;
        }


        /* =====================================================
           QUANTITY / UNIT / VALUE
        ===================================================== */

        .indent-edit-three {
          grid-column: 1 / -1;

          width: 100%;
          min-width: 0;

          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 18px;
        }


        /* =====================================================
           CONSIGNEE
        ===================================================== */

        .indent-edit-consignee {
          width: 100%;
          max-width: 50%;

          min-width: 0;

          margin-top: 18px;
        }


        /* =====================================================
           URGENT SECTION
        ===================================================== */

        .indent-edit-urgent-wrapper {
          grid-column: 1 / -1;

          display: flex;

          justify-content: flex-start;

          align-items: center;

          margin-top: 4px;
        }


        .indent-edit-urgent {
          display: flex;

          align-items: center;

          padding: 7px 14px;

          border: 1px solid #ef9a9a;

          border-radius: 10px;

          background:
            linear-gradient(
              135deg,
              #fff8f8,
              #ffebee
            );

          color: #c62828;

          box-sizing: border-box;
        }


        .indent-edit-urgent .MuiFormControlLabel-label {
          font-size: 13px;

          font-weight: 600;
        }


        .indent-edit-urgent .MuiCheckbox-root {
          padding: 6px;
        }


        /* =====================================================
           ACTION AREA
        ===================================================== */

        .indent-edit-actions {
          display: flex;

          align-items: center;

          justify-content: center;

          gap: 14px;

          width: 100%;

          margin-top: 25px;

          padding: 18px 0 0;

          border-top:
            1px solid #e1e8f0;

          box-sizing: border-box;
        }


        /* =====================================================
           BUTTONS
        ===================================================== */

        .indent-edit-btn {
          min-width: 135px;

          min-height: 42px;

          padding: 10px 22px;

          border: none;

          border-radius: 10px;

          color: #ffffff;

          font-size: 14px;

          font-weight: 700;

          cursor: pointer;

          transition:
            transform 0.18s ease,
            box-shadow 0.18s ease;
        }


        .indent-edit-update {
          background:
            linear-gradient(
              135deg,
              #0d47a1,
              #1976d2
            );

          box-shadow:
            0 4px 12px rgba(21,101,192,0.22);
        }


        .indent-edit-update:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(21,101,192,0.30);
        }


        .indent-edit-close {
          background:
            linear-gradient(
              135deg,
              #c62828,
              #e53935
            );

          box-shadow:
            0 4px 12px rgba(198,40,40,0.18);
        }


        .indent-edit-close:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(198,40,40,0.28);
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 900px) {

          .indent-edit-grid {
            gap: 14px;
          }

          .indent-edit-three {
            gap: 14px;
          }

          .indent-edit-consignee {
            max-width: 100%;
          }
        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 600px) {

          .indent-edit-page {
            padding: 6px;
          }


          .indent-edit-card {
            border-radius: 12px !important;
          }


          .indent-edit-header {
            padding: 15px 16px;
          }


          .indent-edit-title {
            font-size: 17px;
          }


          .indent-edit-subtitle {
            font-size: 11px;
          }


          .indent-edit-content {
            padding: 15px;
          }


          .indent-edit-grid {
            grid-template-columns: 1fr;

            gap: 13px;
          }


          .indent-edit-full {
            grid-column: auto;
          }


          .indent-edit-three {
            grid-column: auto;

            grid-template-columns: 1fr;

            gap: 13px;
          }


          .indent-edit-consignee {
            max-width: 100%;

            margin-top: 13px;
          }


          .indent-edit-urgent-wrapper {
            grid-column: auto;

            width: 100%;
          }


          .indent-edit-urgent {
            width: 100%;

            justify-content: flex-start;

            padding: 6px 10px;
          }


          .indent-edit-urgent .MuiFormControlLabel-label {
            font-size: 12px;
          }


          .indent-edit-actions {
            flex-direction: column;

            align-items: stretch;

            gap: 10px;

            margin-top: 20px;

            padding-top: 15px;
          }


          .indent-edit-btn {
            width: 100%;

            min-height: 44px;
          }
        }


        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 400px) {

          .indent-edit-page {
            padding: 4px;
          }


          .indent-edit-header {
            padding: 13px;
          }


          .indent-edit-title {
            font-size: 16px;
          }


          .indent-edit-content {
            padding: 12px;
          }


          .indent-edit-urgent .MuiFormControlLabel-label {
            font-size: 11px;
          }
        }
      `}
    </style>


    {/* =========================================================
        PAGE
    ========================================================== */}

    <div className="indent-edit-page">

      {/* =======================================================
          CARD
      ======================================================== */}

      <Card className="indent-edit-card">

        {/* =====================================================
            HEADER
        ====================================================== */}

        <div className="indent-edit-header">

          <div className="indent-edit-title">
            Indent Entry Edit
          </div>

          <div className="indent-edit-subtitle">
            Update indent, item, quantity and consignee details
          </div>

        </div>


        {/* =====================================================
            ERROR
        ====================================================== */}

        {error && (
          <ToasterAlerts
            type="error"
            title="Message"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )}


        {/* =====================================================
            CONTENT
        ====================================================== */}

        <CardContent
          sx={{
            padding: 0,
            "&:last-child": {
              paddingBottom: 0,
            },
          }}
        >

          <div className="indent-edit-content">

            {/* =================================================
                SECTION
            ================================================== */}

            <div className="indent-edit-section-title">
              Indent Information
            </div>


            {/* =================================================
                FORM
            ================================================== */}

            <div className="indent-edit-grid">

              {/* ===============================================
                  INDENT NUMBER
              ================================================ */}

              <div className="indent-edit-field">

                <CustomTextField
                  label="Enter Indent Number (Max 50 Characters)*"
                  value={varindentNumber}
                  onChange={(e) => {
                    setvarindentNumber(
                      e.target.value.toUpperCase()
                    );
                  }}
                  placeholder="Enter Indent Number"
                  maxLength={50}
                  multiline={false}
                  error={!!errors.indent}
                  helperText={errors.indent}
                />

              </div>


              {/* ===============================================
                  DATE
              ================================================ */}

              <div className="indent-edit-field">

                <DatePickerComponent
                  label="Date of Indent*"
                  id="indentdate"
                  value={vardateofIndent}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setvardateofIndent
                    )
                  }
                  error={errors.errDate}
                  maxDate={today}
                  minDate={minCalDate}
                />

              </div>


              {/* ===============================================
                  ITEM NAME
              ================================================ */}

              <div className="indent-edit-field indent-edit-full">

                <CustomTextField
                  label="Enter Item Name (Max 200 Characters)*"
                  value={varitemname}
                  onChange={(e) => {
                    setvaritemname(e.target.value);
                  }}
                  placeholder="Enter Item Name"
                  maxLength={200}
                  multiline={true}
                  minRows={3}
                  error={!!errors.name}
                  helperText={errors.name}
                />

              </div>


              {/* ===============================================
                  QUANTITY / UNIT / VALUE
              ================================================ */}

              <div className="indent-edit-three">

                <div className="indent-edit-field">

                  <NumericTextField
                    id="ItemQuantity"
                    label="Item Quantity"
                    title="Item Quantity"
                    error={errors.qty}
                    value={varindentItemQty}
                    onChange={handleQuantityChange}
                  />

                </div>


                <div className="indent-edit-field">

                  <DropdownfromDatabaseList
                    Options={units}
                    option={unit}
                    setOptionValue={setunit}
                    DisplayItem1="unit"
                    DisplayItem2="unitcode"
                    showKeyInLabel={true}
                  />

                </div>


                <div className="indent-edit-field">

                  <NumericTextField
                    id="ItemValue"
                    label="Item Value"
                    title="Item Value"
                    error={errors.val}
                    value={varindentItemValue}
                    onChange={handleValueChange}
                  />

                </div>

              </div>

            </div>


            {/* =================================================
                CONSIGNEE
            ================================================== */}

            <div
              className="indent-edit-section-title"
              style={{
                marginTop: "24px",
              }}
            >
              Consignee Information
            </div>


            <div className="indent-edit-consignee">

              <DropdownfromDatabaseList
                Options={consignees}
                option={consignee}
                setOptionValue={setconsignee}
                DisplayItem1="Shop"
                DisplayItem2="ConsigneeCode"
                showKeyInLabel={true}
                disabled={
                  auth?.userrights ===
                  USER_RIGHTS.CONSIGNEE
                }
              />

            </div>


            {/* =================================================
                URGENT
            ================================================== */}

            {urights === 1 && (
              <div className="indent-edit-urgent-wrapper">

                <div className="indent-edit-urgent">

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        color="primary"
                      />
                    }
                    label="Select If Indent is Urgent Nature"
                  />

                </div>

              </div>
            )}


            {/* =================================================
                ACTION BUTTONS
            ================================================== */}

            <div className="indent-edit-actions">

              <button
                className="
                  indent-edit-btn
                  indent-edit-update
                "
                type="button"
                onClick={UpdateIndentData}
                title="Click for Data Update"
              >
                Update Data
              </button>


              <button
                className="
                  indent-edit-btn
                  indent-edit-close
                "
                type="button"
                onClick={handleClose}
                title="Close"
              >
                Close
              </button>

            </div>

          </div>

        </CardContent>

      </Card>

    </div>
  </>
);
}

export default IndentEdit;
